'use strict';

import { CountUp } from 'countup.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SELECTOR = '.js-counting-value';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches == true ||
        window.matchMedia('(prefers-reduced-motion: reduce)') == true;

    let options = {};

    if (!elements.length) {
        return;
    }

    if (reducedMotion) {
        options = {
            duration: 0,
        };
    }

    elements.forEach(element => {
        const countUp = new CountUp(element, element.getAttribute('data-target'), options);

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom",
            onEnter:function() {
                countUp.start();
                element.parentElement.classList.add('is-visible');
            }
        })
    });
}




